// extracted by mini-css-extract-plugin
var _1 = "RequestAttachTag-modulecontainer__Ph4Oi";
var _2 = "RequestAttachTag-moduledelete__gkiLG";
var _3 = "RequestAttachTag-moduledisabled__vAw7Y";
var _4 = "RequestAttachTag-modulenameContainer__QOrmG";
var _5 = "RequestAttachTag-modulestatusContainer__YCJlf";
var _6 = "RequestAttachTag-moduletitle__VgFOc";
export { _1 as "container", _2 as "delete", _3 as "disabled", _4 as "nameContainer", _5 as "statusContainer", _6 as "title" }
